import { Controller } from "@hotwired/stimulus";
import HSFormSearch from "../theme/hs-form-search.min";

export default class SearchController extends Controller {
  static values = {
    delay: { type: Number, default: 500 },
    url: String, shouldSubmit: Boolean
  };

  connect() {
    this.lastInputValue = ""
    this.formSearch = new HSFormSearch(this.element).getItem(0)
    this.searchTimeout = null

    this.formSearch.events = this?.formSearch?.events || { clear: this.#call() }

    this.formSearch.events.clear = () => {
      $("#search_users").html("<span class='text-white'>No results found!</span>")
    }

    this.formSearch.$el.addEventListener('input', () => {
      const value = this.formSearch.$el.value.trim()

      this.formSearch.loading(true)

      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(async () => {
        this.#search(value)
        this.formSearch.loading(false)
      }, this.delayValue)
    })
    $(this.formSearch.$el).on('change', () => {
      this.formSearch.loading(false)
    })
    this.formSearch.on('clear', () => {
      this.#updateLinks("")
      this.#call();
    })
  }

  #call() {
    const value = this.formSearch.$el.value.trim()

    this.#updateLinks(value)
    this.formSearch.loading(true)

    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(async () => {
      this.#search(value)
      this.formSearch.loading(false)
    }, this.delayValue)
  }

  #search(search_txt) {
    if (this.shouldSubmitValue) {
      this.element.closest('form')?.requestSubmit()
      return
    }

    this.#updateLinks(search_txt)
    if (!this.hasUrlValue) return

    fetch(this.urlValue + encodeURIComponent(search_txt), {
      method: "get",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    }).then((r) => r.text()).then((html) => Turbo.renderStreamMessage(html));
  }

  #updateLinks(searchTxt) {
    document.querySelectorAll("#searchPosts a").forEach(link => {
      const url = new URL(link.href)

      if (searchTxt) {
        url.searchParams.set("search", searchTxt)
      } else {
        url.searchParams.delete("search")
      }

      link.href = url.toString()
    })
  }
}
